import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
// Local Deps
import './InputField.scss';

class InputField extends React.Component {
  handleChange = event => {
    const inputName = event.target.name;
    let inputValue = event.target.value;
    if (!inputValue || inputValue < 0) {
      inputValue = 0;
    }
    this.props.onChange({ inputName, inputValue });
  };

  render() {
    return (
      <label>
        <h4 className="nf-input-field__header">
          {startCase(this.props.inputName)}
        </h4>
        <div className="nf-input-field__input">
          <input
            name={this.props.inputName}
            type="number"
            value={this.props.inputValue}
            onChange={this.handleChange}
          />
        </div>
      </label>
    );
  }
}

InputField.propTypes = {
  inputName: PropTypes.string.isRequired,
  inputValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/form/InputField/InputField.jsx